import React from 'react';
import { Img } from 'ui-kit';
import { LOADER_ICON } from 'assets/icons';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const Loader = ({ fillBackground }) => (
  <Styled.Wrapper data-html2canvas-ignore className="no-print" fillBackground={fillBackground}>
    <Styled.Container>
      <Img src={LOADER_ICON} alt="loader" />
    </Styled.Container>
  </Styled.Wrapper>
);

Loader.propTypes = {
  fillBackground: PropTypes.bool,
};

Loader.defaultProps = {
  fillBackground: false,
};

export default Loader;
